import React from 'react';

export const ProjectCard: React.FC<any> = ({ project, onEdit, onDelete }) => {
  // Usar las props para evitar el error
  console.log({ project, onEdit, onDelete });
  return <div>Project Card</div>;
};